__turbopack_context__.v({
  "contactButton": "index-module-scss-module__MwSkrG__contactButton",
  "skeleton": "index-module-scss-module__MwSkrG__skeleton",
  "switchedTouchPoints": "index-module-scss-module__MwSkrG__switchedTouchPoints",
});
